import React from "react";
// import { Global } from "../helpers/Global";
// import { Peticion } from "../helpers/Peticion";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const Home = () => {
  // const [post, setPost] = useState([]);

  // const conseguirtours = async () => {
  //   let { datos } = await Peticion(Global.url + "post", "GET");

  //   console.log(datos);

  //   if (datos) {
  //     setPost(datos);
  //   }
  // };

  // useEffect(() => {
  //   conseguirtours();
  // }, []);

  return (
    <section class="content__page">
      <h1 class="page__name">Gerlin Gonzalez</h1>
      <h2 class="page__job">Cybersecurity SOC | Linux SysAdmin | DevSecOps</h2>
      <h3 class="page__slogan">"Protegiendo arquitecturas modernas y garantizando alta disponibilidad en entornos Linux."</h3>
    </section>
  );
};
